import { render, staticRenderFns } from "./AboutSalve.vue?vue&type=template&id=5d18fb04&scoped=true&"
import script from "./AboutSalve.vue?vue&type=script&lang=js&"
export * from "./AboutSalve.vue?vue&type=script&lang=js&"
import style0 from "./AboutSalve.vue?vue&type=style&index=0&id=5d18fb04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d18fb04",
  null
  
)

export default component.exports